import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { IHelpButtonProps } from './IHelpButton';
import { useTranslation } from 'react-i18next';
import * as BeMaccaferriStoreHelper from '../../../../api/store/BeMaccaferriStoreHelper';
import { IBlobFileResponse } from '../../../../api/IApiResponse';

const HelpButton = (props: IHelpButtonProps) => {
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const [document, setDocument] = React.useState<IBlobFileResponse[]>([]);

    React.useEffect(() => {
        const fetchAllDocument = async () => {
            let res = await BeMaccaferriStoreHelper.getAllDocumentsAsync();
            setDocument(res.data);
        };

        fetchAllDocument();
    }, []);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-solid fa-question' />
                {t('header_help_button')}
                <i className='fa-solid fa-angle-down' />
            </button>
            <Menu
                id='basic-menu-help'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {document.map((x, index) => {
                    let filename = x.name.split('.');
                    filename.pop();
                    filename.join('.');
                    return (
                        <MenuItem key={`doc${index}`} className={props.className} onClick={handleClose}>
                            <a href={x.url} target='_blank'>
                                {filename}
                            </a>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default HelpButton;
